"use client";

import type { MouseEvent, ReactNode } from "react";
import { usePathname } from "next/navigation";
import { firePhoneClick } from "@/lib/analytics/events";

interface Props {
  phone: string;
  pagePath?: string; // optional override; defaults to current pathname
  vehicleId?: string;
  className?: string;
  children?: ReactNode;
}

export function PhoneLink({ phone, pagePath, vehicleId, className, children }: Props) {
  const currentPath = usePathname();
  const onClick = (_e: MouseEvent<HTMLAnchorElement>) => {
    firePhoneClick({ phone, pagePath: pagePath ?? currentPath ?? "/", vehicleId });
  };
  return (
    <a href={`tel:${phone}`} className={className} onClick={onClick}>
      {children ?? phone}
    </a>
  );
}
